// extracted by mini-css-extract-plugin
export default {"root":"LaunchPanelTabContent_root__RvWA5"};